import { EmployerInfoFragment } from 'src/api';

import {
  CompanyInformationFormEmployerAdminFields,
  CompanyInformationFormEmployerAdminValues,
} from '../types';

export const getInitialValues = (
  employer: EmployerInfoFragment,
): CompanyInformationFormEmployerAdminValues => {
  return {
    [CompanyInformationFormEmployerAdminFields.displayName]: employer.displayName,
    [CompanyInformationFormEmployerAdminFields.industry]: employer.industry,
    [CompanyInformationFormEmployerAdminFields.contactEmail]: employer.contactEmail,
    [CompanyInformationFormEmployerAdminFields.contactPhoneNumber]: employer.contactPhoneNumber,
    [CompanyInformationFormEmployerAdminFields.taxYearEndDate]: employer.taxYearEndDate,
    [CompanyInformationFormEmployerAdminFields.corporateStructure]: employer.corporateStructure,
    [CompanyInformationFormEmployerAdminFields.numberOfEmployees]: employer.numberOfEmployees,
    [CompanyInformationFormEmployerAdminFields.disclaimer]: employer.disclaimer,
    [CompanyInformationFormEmployerAdminFields.logoFile]: employer.logo
      ? {
          id: employer.logo.id,
          size: employer.logo.size,
        }
      : null,
    [CompanyInformationFormEmployerAdminFields.headquarters]: employer.headquarters,
  };
};
